export default __webpack_public_path__ + "files/BC1.pdf";